module.exports = __webpack_public_path__ + "static/media/vtex31.88558b3b.png";